// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const PasteIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="PasteIcon" ref={forwardedRef} {...props}>
      <path d="M14 2a1 1 0 0 1 1 1v3.5h-1.5v-3h-9v11h2V16H4l-.103-.005a1 1 0 0 1-.892-.893L3 15V3a1 1 0 0 1 1-1z" />
      <path d="M6.25 5h5.5v1.5h-5.5z" />
      <path d="M9.5 16.5h6v-7h-6zM17 17l-.005.102a1 1 0 0 1-.893.893L16 18H9l-.103-.005a1 1 0 0 1-.892-.893L8 17V9a1 1 0 0 1 1-1h7a1 1 0 0 1 1 1z" />
    </SvgIcon>
  );
});

/**
 * Use to paste clipboard content
 * @public
 */
export const PasteIcon = /* @__PURE__ */ Object.assign(PasteIconComponent, {
  displayName: 'PasteIcon',
});
